import React from 'react'

import Image from 'next/image'

import { Column, LinkButton, Text } from 'Components/UI'

import { useResponsiveLayout } from 'Hooks'

import { Container, Divider } from './styles'

type Card = {
  id: string
  name?: string
  jobPosition?: string
  handicap?: string
  bioShort?: string
  photo?: {
    id: string
    url?: string
    alt?: string
  }
  avatar?: {
    id: string
    url?: string
    alt?: string
  }
}

type Props = {
  data?: Card
  onAction?: () => void
}

function Card({ data, onAction }: Props) {
  const { isMobile, isTablet, isDesktop, isWideDesktop } = useResponsiveLayout()

  if (!data) return null

  const small = isMobile
  const medium = isTablet && !isDesktop
  const large = isDesktop && !isWideDesktop
  const extraLarge = isWideDesktop

  return (
    <Container width={[280, 280, 280, 350, 350, 390]}>
      <Column alignCenter fullWidth gap={2}>
        {data.photo && data.photo.url && data.photo.alt !== undefined && (
          <Image
            alt={data.avatar?.alt ?? data.photo.alt ?? ''}
            height={160}
            src={data.avatar?.url ?? data.photo.url}
            width={160}
          />
        )}

        <Text
          as="h4"
          bold
          center
          important
          mt={6}
          nowrap
          screen18={small || medium || large}
          screen24={extraLarge}
        >
          {data.name}
        </Text>

        <Text
          accent
          as="h5"
          bold
          center
          screen14={small || medium || large}
          screen20={extraLarge}
        >
          {`${data.jobPosition ?? ''}${data.handicap && ` | ${data.handicap}`}`}
        </Text>
      </Column>

      <Divider my={[3, 3, 3, 3, 3, 6]} />

      <Text
        body
        center
        mb={5}
        regular
        screen14={small || medium}
        screen20={extraLarge || large}
      >
        {data.bioShort}
      </Text>

      <LinkButton onClick={onAction}>Read More</LinkButton>
    </Container>
  )
}

export default Card
